import React from 'react';

import IProduct from 'models/product';
import { InputTextFieldDebounced } from 'components/inputfields/InputTextField';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import { useProductValidations } from '../validation-context/ProductValidationContext';

interface IProps {
  readOnly?: boolean;
  approve?: boolean;
  state: IProduct;
  setState: React.Dispatch<React.SetStateAction<IProduct>>;
}

export const CommodityCode = ({ readOnly, approve, state, setState }: IProps) => {
  const { requiredFields } = useProductValidations();
  let error = '';

  if (!!state.commodityCode && !/^\d{8}$/.test(state.commodityCode)) {
    error = 'Ange en giltig CN-kod – 8 siffror, inga bokstäver eller mellanslag.';
  }

  return (
    <div style={{ display: 'flex', width: '100%', alignItems: 'start' }}>
      <div style={{ flexGrow: 1 }}>
        <InputTextFieldDebounced<IProduct>
          readOnly={readOnly}
          placeholder="Ex. 33049900"
          inputName="commodityCode"
          state={state}
          setState={setState}
          withLabel={true}
          style={{ marginBottom: 0, flex: 'none' }}
          forceRed={!!error}
          errorText={error}
          labelOptions={{
            required: !!requiredFields.commodityCode,
            heading: 'Produktens varukod (CN-kod, 8 siffror)',
            text: 'Varukoden ska motsvara produktens faktiska innehåll och användning. Om ni saknar eller är osäkra på varukod (CN-kod), läs mer på tullverkets hemsida och välj Export-läge.',
            link: 'https://tulltaxan.tullverket.se/ite-tariff-public/#/taric/nomenclature/sbn?sd=2026-04-13&d=I&l=sv&ql=sv',
          }}
        />
      </div>
      {approve && state?.approve?.find(x => x.field === 'commodityCode') && (
        <ThreeWaySwitch
          readOnly={readOnly}
          state={state}
          setState={setState}
          name="commodityCode"
          style={{ marginTop: 58 }}
        />
      )}
    </div>
  );
};

export default CommodityCode;
